export default "__VITE_ASSET__DWuqwj2Y__"